import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { bounceIn } from 'ng-animate'
import { transition, trigger, useAnimation } from '@angular/animations'
import { NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
    selector: 'mg-ui-rounded-input',
    templateUrl: './ui-rounded-input.component.html',
    styleUrls: ['./ui-rounded-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UiRoundedInputComponent),
            multi: true,
        },
    ],
    animations: [trigger('bounceIn', [transition(':enter', useAnimation(bounceIn))])],
})
export class UiRoundedInputComponent extends AbstractValueAccessor {
    @Input()
    label: string

    @Input()
    whiteTheme = false

    @ViewChild('input', { static: true })
    input: ElementRef

    public focus(): void {
        this.input.nativeElement.focus()
    }
}
